<app-modal-header
  [highlighted]="true"
  (close)="close()">

  <span slot="title">
    {{ 'admin.location-picker-modal.title' | translate }}
  </span>
</app-modal-header>

<div class="modal-body flex flex-column">

  <div class="grid">

    <div class="col-12 md:col-4 lg:col-4 xl:col-3">
      <div class="p-input-icon-left w-full">
        <i class="pi pi-search"></i>
        <input
          [formControl]="searchFC"
          pInputText
          type="text"
          class="w-full"
          [placeholder]="'admin.location-picker-modal.search-input.placeholder' | translate"
          />
      </div>
    </div>

    <div class="col-12 md:col-8 lg:col-8 xl:col-9">
      <app-start-at-end-at-input [FG]="datesFG" [whisperValues]="(selectedOrg.selectedOrg$ | async)?.sessionTimeFromToWhisperValues"></app-start-at-end-at-input>
    </div>

  </div>

  <div class="grid flex-auto overflow-auto">

    <div class="col-12  h-full overflow-auto" [class.loading-box]="locationsState.fetchingLocations$ | async">
      <!-- do not rerender timeline, keep it, just hide it for example -->
      <app-timeline
        [locations]="locations"
        [session]="session"
        [sessionLocationId]="locationIdFC.value ?? undefined"
        [shopItem]="shopItem"
        [locationIdsToShow]="filteredLocationIds"
        [sessionDates]="datesFG"
        [selectedDate]="selectedDate ?? undefined"
        [userPreferences]="userPreferences"
        [datesChanged$]="datesChanged$"
        [locationChanged$]="locationChanged$"
        (sessionChange)="onSessionChange($event)"
        >
      </app-timeline>
    </div>


  </div>

</div>

<div class="modal-footer">
  <button
    pButton
    class="p-button-sm"
    [label]="'admin.location-picker-modal.submit-btn.label' | translate"
    (click)="submit()">
  </button>
</div>